import classNames from 'classnames';
import type { FC } from 'react';
import React from 'react';

import Button from '../../../../../../../common/components/Button';
import { useWidget } from '../../../../../../../contexts/widgets';
import { absorbArguments } from '../../../../../../../services/event-handler';
import { DataHook } from '../../../../../../../types';
import styles from './Followers.scss';

export const Followers: FC = () => {
  const { member, globalSettings, handlers, computed } = useWidget();

  const { ffLightboxEnabled, ffLightboxInstalled } = globalSettings;
  const { followersInstalled, profileWidgetTexts } = computed;

  const isCTADisabled = !ffLightboxEnabled && !followersInstalled;

  const handleFollowersBoxClick = absorbArguments(() => {
    if (ffLightboxInstalled) {
      return handlers.showFollowers();
    }

    handlers.navigateToViewedMemberFFPage(true);
  });

  const handleFollowingBoxClick = absorbArguments(() => {
    if (ffLightboxInstalled) {
      return handlers.showFollowing();
    }

    handlers.navigateToViewedMemberFFPage(false);
  });

  return (
    <div data-hook={DataHook.FollowersFollowing} className={styles.numbersBox}>
      <div
        data-hook={DataHook.Followers}
        className={styles.followersBoxContainer}
      >
        <Button
          className={classNames(styles.button, styles.numbersBoxFollowers, {
            [styles.disabled]: isCTADisabled,
          })}
          onClick={handleFollowersBoxClick}
          isDisabled={isCTADisabled}
        >
          <span>{member.followerCount}</span>
          <div className={styles.numbersBoxText}>
            {profileWidgetTexts.followersCountersText}
          </div>
        </Button>
      </div>
      <div className={styles.divider} />
      <div data-hook={DataHook.Following}>
        <Button
          className={classNames(styles.button, styles.numbersBoxFollowing, {
            [styles.disabled]: isCTADisabled,
          })}
          onClick={handleFollowingBoxClick}
          isDisabled={isCTADisabled}
        >
          <span>{member.followingCount}</span>
          <div className={styles.numbersBoxText}>
            {profileWidgetTexts.followingCountersText}
          </div>
        </Button>
      </div>
    </div>
  );
};
